import { Api } from '../../axioscadastro';
import { v4 as uuidv4 } from 'uuid';

type NullableDate = Date | null | undefined;

export interface IListagemTalao {
  idtalao: string;
  numero: number;
  datalan: Date;
  nome: string;
  cpf: string;
  fabrica: string;
}

export interface  IitensTalaoDialog{
  iditens: string;
  descricao: string;
  quantidade: number;
}

interface IgetPedidoDireto {
  idcli: string;
  dataoperacao: Date;
  emissao: Date; 
  numero: string;
  valor: number;
  status: boolean;
  itens: IitensTalaoDialog[];
}

interface IDetalheTalao {
  idcli: string;
  idfabrica: string;
  datalan: Date; 
}

interface IItensImpressao{
 descricao: string;
 quantidade: number;
 un: string;
 preco: number;
 total: number;
 ean: string;
 nome: string;
}

interface IItensids{
  iditens: string;
}

interface Iitens{
  iditens: string;
  idprod: string; 
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  codfabrica: string;
  quantidade: number;
  preco: number;
  total: number;
}

interface ItensImpr {
 descricao: string;
 quantidade: number;
};

export interface IgetImpressaoNota {
  idtalao: string;
  numero: string;
  datalan: Date;
  nome: string;
  cpf: string;
  rg: string;
  fantasia: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  celular: string;
  cep: string;
  logo: string;
  itens: ItensImpr[];
}


type TotalCount = {
  data: IListagemTalao[];
  totalCount: number;
}

interface ErrorResponse {
  data: {
    errors: {
      [key: string]: string;
    };
  };
} 

const getAll = async (page = 1, tipo='', participante='', dataInicial = '', dataFinal='', ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/talao?page=${page}&limit=${17}&tipo=${tipo}&participante=${participante}&inicial=${dataInicial}&final=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);  
 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IgetPedidoDireto | Error> => {
  try {

    const { data } = await Api.get(`/talao/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const getProdutos = async (tipo: string, idfabrica: string, idcli: string,  id: string): Promise<IitensTalaoDialog | Error> => {
  try {
    const { data } = await Api.get(`/produto?idcli=${idcli}&idfabrica=${idfabrica}&tipo=${tipo}&id=${id}`);
    if (data) {  
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (dados: Omit<IDetalheTalao, 'numero'>, dadositens: IitensTalaoDialog[]): Promise<string | Error> => {
  try {   
    const guuid = uuidv4();
    const dadosExtraidos = dadositens.map(({ ...restoDoObjeto }) => ({idtalao: guuid, ...restoDoObjeto }));
    const dadosPedido = {idtalao: guuid, ...dados};
    const { data } = await Api.post<IDetalheTalao>('/talao',  [dadosPedido, dadosExtraidos]); 
    if (Object.keys(data).length === 0) {  
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      return new Error('Erro ao Lançar Entrada');
    }
  }
};

const updateById = async (id: string, dados: Omit<IDetalheTalao, 'numero'>, dadositens: IitensTalaoDialog[], iddeletados: IItensids[]): Promise<void | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({ ...restoDoObjeto }) => ({idtalao: id, ...restoDoObjeto }));
    const { ...dadosIDetalheSaida } = dados;
    const dadosSaida = {idtalao: id, ...dadosIDetalheSaida};

    await Api.put(`/talao/${id}`, [dadosSaida, dadosExtraidos, iddeletados]);

  }  catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      return new Error('Erro ao Lançar Entrada');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/talao/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const Impressao = async (id: string): Promise<IgetImpressaoNota | Error> => {
  try {

    const { data } = await Api.get(`/talaoimpressao/${id}`);

    if (data) { 
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

export const TalaoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getProdutos, 
  Impressao,
};